import { render, staticRenderFns } from "./JurisdictionBoundariesMap.vue?vue&type=template&id=36ed6cce&scoped=true&"
import script from "./JurisdictionBoundariesMap.vue?vue&type=script&lang=js&"
export * from "./JurisdictionBoundariesMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ed6cce",
  null
  
)

export default component.exports